/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Mod_Exp_DescInputs */

const es_faq_mod_exp_desc = /** @type {(inputs: Faq_Mod_Exp_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparte trayectos con costes compartidos. Sin trámites especiales. Puedes empezar ya mismo.`)
};

const gl_faq_mod_exp_desc = /** @type {(inputs: Faq_Mod_Exp_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparte traxectos con custos compartidos. Sen trámites especiais. Podes comezar xa mesmo.`)
};

const en_faq_mod_exp_desc = /** @type {(inputs: Faq_Mod_Exp_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share trips with cost-sharing. No extra paperwork. You can start right away.`)
};

/**
* | output |
* | --- |
* | "Share trips with cost-sharing. No extra paperwork. You can start right away." |
*
* @param {Faq_Mod_Exp_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_mod_exp_desc = /** @type {((inputs?: Faq_Mod_Exp_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Mod_Exp_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_faq_mod_exp_desc(inputs)
	if (locale === "en") return en_faq_mod_exp_desc(inputs)
	return es_faq_mod_exp_desc(inputs)
});